
import IndexModelTable from '@/views/paginas/sigap/modelos/IndexModelTable.vue';
import CardRh from "@/components/cards/ManzaCard.vue";
import UnidadeService from "@/service/v1/sigap/UnidadeService";
import { Options } from "vue-class-component";
import SiteUtils from '@/assets/ts/aplicacao/site';
import KDataTable from "@/components/datatable/newdatatable.vue";
import $ from "jquery";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import Multiselect from '@vueform/multiselect';

@Options({
    name: "UnidadeIndex",
    components: { CardRh, KDataTable, Multiselect },
})
export default class UnidadeIndex extends IndexModelTable {
    public status_id: any = null;
    public status: any = null;
    public tipo_id: any = null;
    public tipos: any = null;
    public search = "";

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE], this.perfis);
    }

    get hasPermissaoAdmin(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    get status_select() {
        if (this.status) {
            return this.status.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    public getStatus() {
        this.processando = true;
        this.service.getStatus()
            .then(response => {
                this.status = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    get tipos_select() {
        if (this.tipos) {
            return this.tipos.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    public getTipos() {
        this.processando = true;
        this.service.getTipos()
            .then(response => {
                this.tipos = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    public limparFiltros() {
        this.search = "";
        this.status_id = null;
        this.tipo_id = null;
        this.refreshTable();
    }

    created() {
        this.service = new UnidadeService();
        this.getStatus();
        this.getTipos();
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    search: this.search || d.search.value,
                    status: this.status_id,
                    tipo: this.tipo_id,
                };
                return dados;
            }
        };

        this.config.columns = [
            { data: 'id', name: 'id', class: 'desktop' },
            { data: 'descricao', name: 'descricao' },
            { data: 'qdi', name: 'qdi', class: 'desktop' },
            { data: 'tipo.nome', name: 'tipo.nome', class: 'desktop' },
            { data: 'status', name: 'status', class: 'desktop' },
        ];
        if (this.hasPermissao) {
            this.config.columnDefs = [
                {
                    targets: 4,
                    render: (row, type, val) => {
                        let texto = '';
                        let buttom = '';
                        for (const key in val) {
                            buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                        }
                        if (row.id == '1') {
                            texto = texto + '<button class="btn btn-success btn-sm" btn-retirar ' + buttom + '>Ativo</button>';
                        }
                        else {
                            texto = texto + '<button class="btn btn-pmes-danger btn-sm" btn-liberar ' + buttom + ' title="Excluir">Inativo</button>';
                        }
                        return texto;
                    },
                },
            ];
        }
    }

    public tableatualizada() {
        $("[btn-excluir]").click((btn) => {
            const id = $(btn.currentTarget).data('id');
            this.excluirModelo(id);
        });
        $("[btn-liberar]").click((btn) => {
            if (this.hasPermissao) {
                const id = $(btn.currentTarget).data('id');
                this.liberarUnidade(id);
            }
        });
        $("[btn-retirar]").click((btn) => {
            if (this.hasPermissao) {
                const id = $(btn.currentTarget).data('id');
                this.removerUnidade(id);
            }
        });
    }

    protected liberarUnidade(id) {
        this.processando = true;
        setTimeout(() => {
            this.service.ativar(id)
                .then(() => {
                    this.reloadDatatable = !this.reloadDatatable;
                    SiteUtils.toastSucesso('Acesso liberado com sucesso!!');
                    this.processando = false;
                })
                .catch(() => {
                    this.processando = false;
                });
        }, 10);
    }

    protected removerUnidade(id) {
        this.processando = true;
        setTimeout(() => {
            this.service.inativar(id)
                .then(() => {
                    this.reloadDatatable = !this.reloadDatatable;
                    SiteUtils.toastSucesso('Acesso removido com sucesso!!');
                    this.processando = false;
                })
                .catch(() => {
                    this.processando = false;
                });
        }, 10);
    }

    protected sincronizarViaRh() {
        this.processando = true;
        setTimeout(() => {
            this.service.sincronizarViaRh()
                .then(() => {
                    this.reloadDatatable = !this.reloadDatatable;
                    SiteUtils.toastSucesso('sucesso!!');
                    this.processando = false;
                })
                .catch(() => {
                    this.processando = false;
                });
        }, 10);
    }
}
